import React, { Component } from "react";

class SegmentedControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: props.defaultIndex || 0,
      componentReady: false
    };
    this.componentReady = React.createRef();
  }

  componentDidMount() {
    const { segments, controlRef } = this.props;
    const { activeIndex } = this.state;
    
    // Use activeIndex to get the dimensions of the default segment
    const defaultSegmentRef = segments[activeIndex].ref;
    const { offsetWidth, offsetLeft } = defaultSegmentRef.current;

    // Set the initial styles for the pseudo-element
    const { style } = controlRef.current;
    style.setProperty("--highlight-width", `${offsetWidth}px`);
    style.setProperty("--highlight-x-pos", `${offsetLeft}px`);

    // Mark the component as ready
    this.setState({ componentReady: true });
  }

  componentDidUpdate(prevProps, prevState) {
    const { segments, callback, controlRef } = this.props;
    const { activeIndex } = this.state;

    if (
      prevState.activeIndex !== activeIndex ||
      prevProps.segments !== segments ||
      prevProps.callback !== callback ||
      prevProps.controlRef !== controlRef
    ) {
      const activeSegmentRef = segments[activeIndex].ref;
      const { offsetWidth, offsetLeft } = activeSegmentRef.current;
      const { style } = controlRef.current;

      style.setProperty("--highlight-width", `${offsetWidth}px`);
      style.setProperty("--highlight-x-pos", `${offsetLeft}px`);
    }
  }

  onInputChange = (value, index) => {
    this.setState({ activeIndex: index });
    this.props.callback(value, index);
  };

  render() {
    const { name, segments, controlRef } = this.props;
    const { activeIndex, componentReady } = this.state;

    return (
      <div className="controls-container" ref={controlRef}>
        <div className={`controls ${componentReady ? "ready" : "idle"}`}>
          {segments?.map((item, i) => (
            <div 
              key={item.value} 
              className={`segment ${i === activeIndex ? "active" : "inactive"}`}
              ref={item.ref}
            >
              <input
                type="radio"
                value={item.value}
                id={item.label}
                name={name}
                onChange={() => this.onInputChange(item.value, i)}
                checked={i === activeIndex}
              />
              <label htmlFor={item.label}>{item.label}</label>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default SegmentedControl;
